import React, { Component } from 'react';
import InserirFiscalizacao from './InserirFiscalizacao';
import TipoOptionForm from './TipoOptionForm';

class MyButtonCell extends Component {

  handleChange = () => {
    console.log("HandleChange called"); // Adicionado para depuração
    InserirFiscalizacao.openInserirvasilha();
    // TipoOptionForm.GetDimencoesCampos();
  }

  componentDidMount() {
    // Não é necessário ser assíncrono aqui, a menos que tenha uma lógica específica
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field
    });
  }

  render() {
    console.log("Rendering MyButtonCell");
    const { dataItem } = this.props;
    const field = this.props.field || '';
    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    // Adicionando logs para depuração
    console.log("dataItem:", dataItem);

    return (
      <td>
        {dataItem.inEdit && (dataItem.N_Vasilha_granel !== undefined || dataItem.N_Vasilha !== undefined) ? (
          <button
            id='buttonCalculator'
            data-toggle="modal"
            data-target='#left-popup-center'
            style={{ border: "none", backgroundColor: "transparent", paddingLeft: "12px", display: "block" }}
            onClick={this.handleChange}
          >
            <i className="fas fa-calculator"></i>
          </button>
        ) : (
          <button
            id='buttonCalculator'
            data-toggle="modal"
            data-target='#left-popup-center'
            style={{ border: "none", backgroundColor: "transparent", paddingLeft: "12px", display: "none" }}
            onClick={this.handleChange}
          >
            <i className="fas fa-calculator"></i>
          </button>
        )}
      </td>
    );
  }
}

export default MyButtonCell;